import { render, staticRenderFns } from "./CadastrarMedicoServico.vue?vue&type=template&id=0344addd&scoped=true"
import script from "./CadastrarMedicoServico.vue?vue&type=script&lang=js"
export * from "./CadastrarMedicoServico.vue?vue&type=script&lang=js"
import style0 from "./CadastrarMedicoServico.vue?vue&type=style&index=0&id=0344addd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0344addd",
  null
  
)

export default component.exports